<template>
  <div class="bottom-menu-links w-100">
    <div class="small">
      <span>VIACOR APP - </span>
      <span class="font-weight-bold">v{{ require('../../../package.json').version }}</span>
      <span>({{ require('../../../package.json').buildNumber }})</span>
    </div>
    <div class="d-flex justify-content-around px-3 py-2 border-top bg-white">
      <el-link type="danger" @click="$emit('logout')">
        {{ $t('general.logout') }}
      </el-link>
      <el-link @click="$emit('account')">
        {{ $t('general.my_account') }}
      </el-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BottomLinkBar',
  components: {},
  props: {},
  mounted() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.bottom-menu-links {
  padding-top: 8px;
  margin-bottom: calc(env(safe-area-inset-bottom));
}
</style>
